import Model from "./Model.js";

export default class Config extends Model {
	
	constructor() {
		super("configuraciones");
	}
	
}
